import React from 'react'
import Hero from '../components/Hero'
import Layout from '../components/Layout'
import Posts from '../components/Posts'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { Link } from 'gatsby'

// updated page

const IndexPage = ({ data }) => {
  const {
    allMdx: { nodes: posts },
  } = data

  const APP_NAME = 'Devsrcblog'

  return (
    <React.Fragment>
      <Helmet>
        <title>Home page | {APP_NAME}</title>
        <meta
          name="description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <link
          rel="canonical"
          href="https://mdx-blog-testing-mode.netlify.app/"
        />
        <meta
          property="og:title"
          content={`Latest web developoment tutorials | ${APP_NAME}`}
        />
        <meta
          property="og:description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <meta property="og:type" content="webiste" />
        <meta
          property="og:url"
          content="https://mdx-blog-testing-mode.netlify.app/"
        />
        <meta property="og:site_name" content={`${APP_NAME}`} />

        <meta
          property="og:image"
          content={`https://mdx-blog-testing-mode.netlify.app/static/mainImg.png`}
        />
        <meta
          property="og:image:secure_url"
          content={`https://mdx-blog-testing-mode.netlify.app/static/mainImg.png`}
        />
        <meta property="og:image:type" content="image/jpg" />
      </Helmet>

      <Layout>
        <Hero showPerson />
        <Posts posts={posts} title="recently published" />
        <Link to="/posts" className="btn center-btn">
          all posts
        </Link>
      </Layout>
    </React.Fragment>
  )
}

export const query = graphql`
  {
    allMdx(limit: 10, sort: { fields: frontmatter___date, order: DESC }) {
      nodes {
        excerpt
        frontmatter {
          title
          author
          category
          date(formatString: "MMMM, Do YYYY")
          slug
          readTime
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        id
      }
    }
  }
`

export default IndexPage

// updated
